// Prepared resources have separate local and authenticated Stage2 origins.
export const resolveResourceOrigin = (env = process.env) => {
  const origin = env.TYPESENSE_LOCAL_RESOURCE_ORIGIN;
  if (!origin) {
    const packageSha256 = env.STAGE2_RESOURCE_PACKAGE_SHA256;
    if (!packageSha256) return 'https://cdn.ticketlens.com';
    if (
      env.SEARCH_BACKEND !== 'typesense' ||
      ![true, 'true'].includes(env.IS_STAGE_2) ||
      typeof packageSha256 !== 'string' ||
      !/^[a-f0-9]{64}$/.test(packageSha256)
    )
      throw new Error('Prepared hosted resources require an exact Stage2 package hash');
    return `https://stage2.ticketlens.com/__preview-resources/${packageSha256}`;
  }
  const url = new URL(origin);
  if (
    env.NODE_ENV === 'production' ||
    env.SEARCH_BACKEND !== 'typesense' ||
    url.protocol !== 'http:' ||
    url.hostname !== '127.0.0.1' ||
    !url.port ||
    url.username ||
    url.password ||
    url.pathname !== '/' ||
    url.search ||
    url.hash
  )
    throw new Error('Prepared resources require a loopback-only development Typesense preview');
  return url.origin;
};
